module.exports = __webpack_public_path__ + "static/media/02.827844bf.gif";